import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isCovered } from "../shared/utils";
import { Popup } from "semantic-ui-react";
import { dateFormat } from "../shared/constants";

export const TimelineMinimap = ({ priceList, elements }) => {
    const toMoment = (val) => moment.isMoment(val) ? val : moment(val);
    const getPercent = (date, rangeStart, rangeEnd) => {
        const total = rangeEnd.diff(rangeStart);
        const part = date.diff(rangeStart);
        return (part / total) * 100;
    };

    const startDate = toMoment(priceList.StartDate);
    const endDate = toMoment(priceList.EndDate);

    const {hasGap, normalizedElements} = isCovered(priceList, elements)

    return (<div 
        className={`ui tiny progress ${hasGap ? "orange" : "green"}`} 
        style={{ height: "0.5em", overflow: "hidden", marginBottom: "0.5em" }}
        data-start={startDate.format("YYYY-MM-DD")}
        data-end={endDate.format("YYYY-MM-DD")}
        >
        {normalizedElements.map((el, id) => {
            const left = getPercent(el.Start, startDate, endDate);
            const right = getPercent(el.End, startDate, endDate);
            const width = right - left;
            const content = `${el.Start.format(dateFormat)} - ${el.End.format(dateFormat)}`;
            return (
                <Popup key={id} content={content} trigger={
                <div
                    key={id}
                    className="bar"
                    style={{
                        position: "absolute",
                        left: `${left}%`,
                        width: `${width}%`
                    }}
                    data-start={el.Start.format("YYYY-MM-DD")}
                    data-end={el.End.format("YYYY-MM-DD")}
                />} ></Popup>
            )
        })}
    </div>)
}

TimelineMinimap.propTypes = {
    priceList: PropTypes.shape({
        StartDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        EndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    }).isRequired,
    elements: PropTypes.arrayOf(
        PropTypes.shape({
            StartDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
            EndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
        })
    ).isRequired,
};